(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nsb-compact-reviews"] && !Shopify.designMode) return;
  try {
    
  function nsbOpenReviews(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.junip-product-summary-star-ratings-container')) return;
    const reviews = document.querySelector('.nsb-reviews__disclosure');
    if (reviews) reviews.open = true;
  }
  document.addEventListener('click', nsbOpenReviews, true);
  document.addEventListener('keydown', nsbOpenReviews, true);

  } catch(e) { console.error(e); }
})();
})();
